module.exports = __webpack_public_path__ + "static/media/stofferingen-20.13a270b4.jpg";